export enum ContentTypes {
    json = 'application/json',
    urlencoded = 'application/x-www-form-urlencoded'
}
